import kbtn from './kbtn.vue'

kbtn.install = function (app) {
  app.component(kbtn.name, kbtn)
}

export default kbtn


//////////////////
// WEBPACK FOOTER
// ./packages/kbtn/index.js
// module id = null
// module chunks = 